<script setup lang="ts">
import { WidthVariants } from '~/types/Content'
import { cardTransformer, CardFields } from './cardHelpers'

type TwoUpCardPanelProps = {
  cards: CardFields[]
  width?: WidthVariants
  title?: string
}

const props = defineProps<TwoUpCardPanelProps>()
const preset = props.width === 'wide' ? 'two-up-wide' : 'two-up'
</script>

<template>
  <section class="twoup-panel" data-testid="twoup-panel">
    <div :class="width === 'wide' ? 'container-full' : 'container-custom'">
      <div class="twoup-panel__header">
        <h3 class="twoup-panel__title heading-2" v-if="title">{{ title }}</h3>
      </div>
      <div class="twoup-panel__cards">
        <Card v-for="card in cards.slice(0, 2)" v-bind="cardTransformer(card)" variant="two-up" :preset="preset" />
      </div>
    </div>
  </section>
</template>

<style lang="postcss">
.twoup-panel {
  margin-bottom: var(--component-space);

  .container-custom {
    margin: 0 auto;
    max-width: var(--container-max-width); /* 1280px */
    @media (--tablet) {
      padding-inline: var(--space-20);
    }
    @media (--desktop) {
      padding-inline: 1rem;
    }
  }
  .container-full {
    @media (--mobile-only) {
      padding-inline: 0;
    }
  }

  .twoup-panel__header {
    text-align: center;
  }

  .twoup-panel__title {
    margin-bottom: var(--space-70);
  }

  .twoup-panel__cards {
    width: 100%;
    margin-top: var(--space-90);
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    column-gap: var(--space-20);
    row-gap: var(--space-90);
    overflow: hidden;

    @media (--tablet) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
</style>
.
